<template>
  <div class="login_content">
    <div class="downloadLayerShow"></div>
    <div class="downloadApp">
      <img src="../assets/images/login/logo.png" />
      <p>音乐窝 Musicwow 直播系统</p>
      <p class="downloadText">下载APP了解更多</p>
      <div class="download">
        <button @click="downloadShowBut">APP下载</button>
      </div>
      <div class="login">
        <button @click="loginShowBut">用户登录</button>
      </div>
    </div>
    <div class="showDownload">
      <div
        class="downloadLayer"
        v-show="downloadLayerFristShow"
        @click="downloadLayerFristBut"
      ></div>
      <div class="loginQrcode" v-show="downloadLayerShow">
        <div class="loginQrcode-log">
          <img src="../assets/images/login/logo.png" />
        </div>
        <div class="loginQrcode-all" style="justify-content: center">
          <!-- <div class="loginQrcode-left">
            <div class="qrcodeLogin">音乐窝APP扫码登录</div>
            <div class="left-Qrcode">
              <div class="qrcode-look">
                <canvas id="qrcode-stage"></canvas>
              </div>
            </div>
          </div> -->
          <div class="loginQrcode-right" style="margin: 0">
            <div class="title">手机号登录</div>
            <el-row>
              <el-col :span="6">
                <el-input v-model="areaCode" placeholder="+86"></el-input>
              </el-col>
              <el-col :span="18">
                <el-input
                  v-model="mobile"
                  maxlength="11"
                  placeholder="请输入手机号码"
                ></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-input
                  v-model="code"
                  maxlength="6"
                  placeholder="请输入验证码"
                  @keyup.enter.native="onCodeLoginBut"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <el-button
                  v-show="onCodeText"
                  @click="onCodeBut"
                  :disabled="isDisabled"
                  >获取验证码</el-button
                >
                <el-button type="info" v-show="onCodeNum">{{ sec }}s</el-button>
              </el-col>
            </el-row>
            <el-button class="login-btn" @click="onCodeLoginBut"
              >登录</el-button
            >
          </div>
        </div>
      </div>
      <div class="downloadQrcode" v-show="loginLayerShow">
        <div class="loginQrcode-log">
          <img src="../assets/images/login/logo.png" />
        </div>
        <div class="downloadQrcode-all">
          <div class="downloadQrcode-right">
            <img src="../assets/images/login/image_1.png" />
          </div>
          <div class="downloadCode-all">
            <div class="downloadQrcode-left">
              <div class="qrcodeLogin">音乐窝APP扫码下载</div>
              <div class="downloadQrcode-Qrcode">
                <div class="qrcode-look">
                  <img
                    class="qrcodeImg"
                    src="../assets/images/login/downloadCode.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRcode from "qrcode";
export default {
  data() {
    return {
      downloadLayerFristShow: false, //遮罩层
      downloadLayerShow: false, //登录页显示
      loginLayerShow: false, //下载页显示
      msg: "", //二维码参数
      str: "", //轮询扫码参数
      areaCode: "86", // 手机区号
      mobile: "", // 手机号码
      code: "", // 验证码
      onCodeText: true, //显示文本
      onCodeNum: false, //显示倒计时
      sec: 60, //倒计时时间
      isDisabled: false, //防止多次点击获取验证码
      timer: "", //定时器
    };
  },
  mounted() {
    this.getQrcodeData();
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    // 显示下载页面
    downloadShowBut() {
      this.loginLayerShow = true;
      this.downloadLayerFristShow = true;
    },
    // 显示登录页面
    loginShowBut() {
      this.downloadLayerShow = true;
      this.downloadLayerFristShow = true;
      this.qrcodeCheck();
    },
    // 轮询检测是否扫码
    qrcodeCheck() {
      this.$request
        .getQrcodeState({
          type: "pc_login",
          code: this.str,
        })
        .then((res) => {
          this.timer = setTimeout(() => {
            this.qrcodeCheck();
          }, 3000);
          if (res.error_code == 0) {
            if (res.data != null) {
              localStorage.setItem("user_token", res.data.token);
              localStorage.setItem(
                "setUserInfo",
                JSON.stringify(res.data.user)
              );
              this.$store.commit("setUserInfo", res.data.user);
              this.$router.replace("/profile");
            }
          }
        });
    },
    // 获取二维码需要的数据
    getQrcodeData() {
      this.$request
        .getQrcodeData({
          type: "pc_login",
        })
        .then((res) => {
          this.str = res.data.code;
          this.msg = `type=pc_login&code=${res.data.code}`;
          const canvas = document.querySelector("#qrcode-stage");
          QRcode.toCanvas(canvas, this.msg, {
            width: 140,
            height: 140,
          });
        });
    },
    // 遮罩层显示与隐藏
    downloadLayerFristBut() {
      this.downloadLayerShow = false;
      this.downloadLayerFristShow = false;
      this.loginLayerShow = false;
      clearInterval(this.timer);
    },
    // 验证码登录
    onCodeLoginBut() {
      if (this.mobile.trim() == "") {
        this.$message({
          message: "手机号不能为空",
          type: "warning",
        });
        return;
      }
      if (this.areaCode.trim() == "") {
        this.$message({
          message: "手机区号不能为空",
          type: "warning",
        });
        return;
      }
      if (this.code.trim() == "") {
        this.$message({
          message: "验证码不能为空",
          type: "warning",
        });
        return;
      }
      this.$request
        .goCodeLogin({
          area_code: this.areaCode,
          mobile: this.mobile,
          code: this.code,
        })
        .then((res) => {
          if (res.error_code == 0) {
            this.$message({
              message: "登录成功",
              type: "success",
            });
            localStorage.setItem("user_token", res.data.token);
            localStorage.setItem("setUserInfo", JSON.stringify(res.data.user));
            this.$store.commit("setUserInfo", res.data.user);
            this.$router.replace("/profile");
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        });
    },
    // 获取验证码
    onCodeBut() {
      if (this.mobile.trim() == "") {
        this.$message({
          message: "手机号不能为空",
          type: "warning",
        });
        return;
      }
      if (this.areaCode.trim() == "") {
        this.$message({
          message: "手机区号不能为空",
          type: "warning",
        });
        return;
      }
      this.$request
        .getCode({
          area_code: this.areaCode,
          mobile: this.mobile,
          event: "login",
        })
        .then((res) => {
          console.log(res);
          if (res.error_code == 0) {
            this.$message({
              message: "发送成功",
              type: "success",
            });
            this.onCodeNum = true;
            this.onCodeText = false;
            this.isDisabled = true;
            this.sec = 60;
            var auth_timetimer = setInterval(() => {
              this.sec--;
              if (this.sec <= 0) {
                this.onCodeText = true;
                this.onCodeNum = false;
                this.isDisabled = false;
                clearInterval(auth_timetimer);
              }
            }, 1000);
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.login_content {
  .downloadLayerShow {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.2);
    z-index: 5;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .downloadApp {
    position: absolute;
    z-index: 6;
    /* padding: 20px; */
    text-align: center;
    width: 100%;
    margin-top: 200px;
    color: #fff;
    img {
      width: auto;
      height: 54px;
    }
    p {
      margin: 16px;
    }
    .downloadText {
      max-width: 600px;
      margin: 10px auto;
    }
    div {
      margin: 15px;
      button {
        background: rgba(0, 0, 0, 0.4);
        border: none;
        padding: 10px;
        width: 100px;
        border-radius: 20px;
        color: #fff;
        cursor: pointer;
        outline: none;
        font-size: 14px;
      }
    }
    .download {
      padding-top: 50px;
    }
  }
  .showDownload {
    .downloadLayer {
      width: 100%;
      height: 100%;
      position: fixed;
      background: rgba(255, 255, 255, 0.8);
      z-index: 8;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
    .loginQrcode {
      padding: 30px;
      position: fixed;
      z-index: 9;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: 0 auto;
      width: 900px;
      height: 450px;
      // left: 26%;
      background: #fff;
      top: 150px;
      .loginQrcode-log {
        text-align: center;
        img {
          width: auto;
          height: 54px;
        }
      }
      .loginQrcode-all {
        display: flex;
        margin-top: 50px;
        & > div {
          width: 46%;
        }
        .loginQrcode-left {
          border-right: 1px solid #cccccc;
          .qrcodeLogin {
            text-align: center;
            font-size: 20px;
          }
          .left-Qrcode {
            width: 400px;
            margin: auto;
            .qrcode-look {
              width: 100%;
              height: 240px;
              background: url("../assets/images/login/QRcode.png");
              background-size: 100% 100%;
              border-radius: 5px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
        .loginQrcode-right {
          margin-left: auto;
          .title {
            font-size: 20px;
            line-height: 50px;
            text-align: left;
          }
          .el-row {
            margin-bottom: 20px;
          }
          .el-button {
            width: 100%;
          }
          .login-btn {
            background: #0bc4a1;
            width: 100%;
            color: #fff;
            font-size: 14px;
          }
        }
      }
    }
    .downloadQrcode {
      padding: 30px;
      position: fixed;
      z-index: 9;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 900px;
      height: 450px;
      // left: 26%;
      margin: 0 auto;
      background: #fff;
      top: 150px;
      .loginQrcode-log {
        img {
          width: auto;
          height: 54px;
        }
      }
      .downloadQrcode-all {
        display: flex;
        margin-top: 50px;
        .downloadQrcode-right {
          border-right: 1px solid #cccccc;
        }
        .downloadCode-all {
          width: 46%;
          .downloadQrcode-left {
            margin-left: auto;
            .qrcodeLogin {
              text-align: center;
              font-size: 20px;
            }
            .downloadQrcode-Qrcode {
              .qrcode-look {
                width: 100%;
                height: 240px;
                background: url(../assets/images/login/QRcode.png);
                background-size: 100% 100%;
                border-radius: 5px;
                margin: auto;
                text-align: center;
                .qrcodeImg {
                  width: 140px;
                  height: 140px;
                  margin-top: 50px;
                  margin-left: 7px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
